import React from 'react';
import Modal from 'react-modal';
import { competencies } from '../data/competencies.js';
import { competencyHeaders } from '../data/competency-headers.js'
import { Context } from './Context.js';

Modal.setAppElement('#root');

export function InfoModal({ id, isOpen, closeModal, headerID }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Example Modal"
    >
      {competencies[id] && (
        <div className="modal-content">
          <header>
            <h2>
              <span className={headerID}>{competencies[id].id} </span>
              {competencies[id].header} 
            </h2>
            <button onClick={closeModal}>&#x2715;</button>
          </header>
          <section>
            <p>{competencies[id].text}</p>
            <p className="bold">Vägledaren känner till och förstår</p>
            <ul>
              {competencies[id].tunnistaa_ja_ymmartaa.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="bold">Vägledaren kan</p>
            <ul>
              {competencies[id].osaa.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>
          {competencies[id].hasOwnProperty('context_competencies') ? (
            <Context
              contextArray={competencies[id].context_competencies}
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </Modal>
  );
}
